module.exports = __webpack_public_path__ + "media/images/brand_logos/redcare-logo-md-fa1ba12aa8f29a5ed919df6766291c03.png";